import { render } from "./studioAdd.vue?vue&type=template&id=40ae86d4&scoped=true"
import script from "./studioAdd.vue?vue&type=script&lang=js"
export * from "./studioAdd.vue?vue&type=script&lang=js"

import "./studioAdd.vue?vue&type=style&index=0&id=40ae86d4&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40ae86d4"]])

export default __exports__